import React, {useEffect, useState} from 'react';
import {TimePicker} from '@mui/x-date-pickers/TimePicker';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';
import {useDispatch} from 'react-redux';
import moment from 'moment/moment';
import {setFields} from '../../store/builder/reducer';

const FillTime = ({disabled, item, readOnly, inspection_id}) => {
  const dispatch = useDispatch();
  const [time, setTime] = useState(null);

  function timeToSeconds(time) {
    if (!time || !moment.isMoment(time)) {
      return 0;
    }
    const hours = time.hours();
    const minutes = time.minutes();
    return hours * 3600 + minutes * 60;
  }

  function secondsToTime(seconds) {
    const hours = Math.floor(Number(seconds) / 3600);
    const minutes = Math.floor((Number(seconds) % 3600) / 60);
    return moment().hours(hours).minutes(minutes);
  }

  useEffect(() => {
    if (item.answers[0]) {
      setTime(secondsToTime(item.answers[0]));
    }
  }, [item]);

  useEffect(() => {
    let inputData = {
      id: item.id,
      answers: [`${time !== null ? timeToSeconds(time) : ''}`],
      has_comment: false,
      comment_text: item?.comment_text,
      comment_files: item.comment_files,
    };
    dispatch(setFields(inputData));
  }, [time]);

  return (
    <div className='fillInspection__field-time'>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <TimePicker
          disabled={readOnly || disabled}
          value={time}
          onChange={(newTime) => setTime(newTime)}
          format="hh:mm A"
          slotProps={{
            textField: {
              size: 'small',
              className: 'fillInspection__field-time'
            }
          }}
        />
      </LocalizationProvider>
    </div>
  );
};

export default FillTime;
